import { useTranslation } from 'react-i18next';
import { CheckBoxField } from 'components/core';

interface AdminScopeWarningProps {
  /** The name of the Admin scope role being granted. */
  roleLabel: string;
  confirmed: boolean;
  onToggle: () => void;
}

// Shown once an Admin scope role is picked: it gives full platform access, so the person saving has to say they mean it.
export const AdminScopeWarning = ({ roleLabel, confirmed, onToggle }: AdminScopeWarningProps) => {
  const { t } = useTranslation();
  return (
    <div className="alert alert-danger mt-3 mb-0">
      <div role="alert">
        <div className="fw-bold d-flex align-items-center gap-1">
          <span className="material-icons fs-5" aria-hidden="true">warning_amber</span>
          {t('USER.ADMIN_WARNING_TITLE')}
        </div>
        <div className="small mb-2">{t('USER.ADMIN_WARNING_TEXT')}</div>
      </div>
      <CheckBoxField isChecked={confirmed} label={t('USER.ADMIN_CONFIRM_LABEL', { role: roleLabel })} clickHandler={onToggle} />
    </div>
  );
};
